// sprechende key Konstanten
export const ENTER = 'Enter';
export const BACKSPACE = 'Backspace';
export const DELETE = 'Delete';
export const TAB = 'Tab';
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const ESCAPE = 'Escape';

// RegEx Konstanten
export const IBAN_REGEX =
  '^[A-Z]{2}\\d{2} (?:[A-Z0-9]{4} ){2,6}(?:[A-Z0-9]{1,4})?$';

// Auftragstypen
export const AUFTRAGSTYP_DEFAULT = 0;
export const AUFTRAGSTYP_KALKULATION = 11;
export const AUFTRAGSTYP_VORLAGE = 51;

// Stati

export const STATUS_ERFASST_INTERNET = 1;
export const STATUS_ZU_UEBERTRAGEN = 2;
export const STATUS_UEBERTRAGEN = 3;

// Laender
export const LAND_ID_AT = 1;

// DLA
export const DLA_ID_BEXITY_BEX = 1;
export const DLA_ID_BEXITY_RS = 4;
